import { apiClient } from './client';
import type { DirectoryMember } from '@/types/oscar';

/**
 * Entra directory lookup for the OnPass recipient picker
 * (oscar/api/Functions/UsersFunctions.cs). Returns enabled, member (non-guest)
 * users matching the query on display name / mail / UPN. Gated server-side by
 * the OnPass audience; the API also re-validates the chosen recipient on send.
 */
export function searchUsers(query: string, signal?: AbortSignal): Promise<DirectoryMember[]> {
  return apiClient.get<DirectoryMember[]>(`/api/users/search?q=${encodeURIComponent(query)}`, signal);
}
